export default "__VITE_ASSET__f8db598c__"